import Messages from './messages-container';

export default Messages;
